import { Component, inject, input, output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SafeHtmlPipe } from '../../core/pipes/safe-html.pipe';
import { DIALOG_CLOSE } from '../../core/models/tokens';
import { NotificationPreamble, NotificationStep } from '../../core/models/notification.model';

@Component({
  selector: 'wf-notification-layout',
  standalone: true,
  imports: [RouterModule, SafeHtmlPipe],
  templateUrl: './notification-detail-layout.component.html',
  styleUrl: './notification-detail-layout.component.css'
})
export class NotificationLayoutComponent {
  private readonly router = inject(Router);
  private readonly closeDialog = inject(DIALOG_CLOSE, { optional: true });
  readonly headerTitle = input.required<string>();
  readonly preambles = input<NotificationPreamble[]>([]);
  readonly steps = input<NotificationStep[]>([]);
  readonly ctaLabel = input.required<string>();
  readonly ctaRoute = input.required<string>();
  readonly closingText = input<string>('');
  readonly usageHighlight = input<string>('');
  readonly isOpen = input<boolean>(false);
  readonly onClose = output<void>();

  handleRouteClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    event.preventDefault();
    if (target.tagName === 'A' && target.hasAttribute('data-route')) {
      event.preventDefault();

      const route = target.getAttribute('data-route') as string;
      if (route) {
        this.router.navigateByUrl(route);
      }
    }
  }

  handleClose() {
    this.closeDialog?.();
  }
}
